import { dateConvert } from "utilities2"

export const submitMapper = (values) => {
  return {
    status_approval: values.status_approval,
    catatan_internal: values.catatan_internal,
    catatan_tindakan: values.catatan_tindakan,
    tgl_approval: dateConvert().getSlashDMY(new Date()),
    no_transaksi: values.no_permintaan_perubahan_data_master,
  }
}
